import { InputField } from "@/components/common/input";
import { emailField } from "@/pages/quiz/base/questions/contactField/validationRules";
import Textarea from "@/components/Textarea";
import { useState } from "react";
import QuestionContentDisplay from "@/pages/quiz/base/components/progressHeader/components/QuestionContentDisplay";
import { Button, ButtonType } from "@/components/common/button";
import { useManageInputFields } from "@/pages/quiz/hooks/useManageInputFields";

type FormFieldName = "email" | "comments";
type ContactFieldsValues = Record<FormFieldName, string>;

const validationFields = {
  email: emailField,
  comments: {
    required: true,
  },
};

const FeedbackForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isRequestSuccessful, setIsRequestSuccessful] = useState(false);
  const [values, setValues] = useState<ContactFieldsValues>({
    comments: "",
    email: "",
  });

  const { registerField, error } = useManageInputFields(
    {
      setQuestionValue: setValues,
      questionValue: values,
    },
    validationFields
  );

  const isNoErrors = Object.values(error).every(
    (errorMessage) => !errorMessage
  );

  const isAllAnswered = !!values.email;

  const isFormAnswered = isAllAnswered && isNoErrors;

  const onSubmit = async () => {
    try {
      setIsLoading(true);

      try {
        const res = await fetch(
          "https://app.skinnyrx.com/api/v1/marketing/subscribe",
          {
            method: "POST",
            headers: {
              "content-type": "application/json",
            },
            body: JSON.stringify({
              email: values.email.toLowerCase(),
            }),
          }
        );
      } catch (e) {
        console.error(e);
      }
      if (isFormAnswered) {
        setIsRequestSuccessful(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isRequestSuccessful ? (
        <QuestionContentDisplay
          question={"Thanks!"}
          prompt={
            "We will reach out to you soon to assist with your request. Thank you for reaching out!"
          }
        />
      ) : (
        <>
          <QuestionContentDisplay
            question={"How can we help?"}
            prompt={
              "Unfortunately we cannot ship treatments to your state. We will be happy to reach you with updates"
            }
          />
          <div className="w-full flex-col flex gap-4">
            <InputField
              {...registerField("email")}
              label="Email"
              placeholder="example@email.com"
            />
            <div className="flex flex-col ">
              <label className="text-sm mb-2 text-left font-roboto">
                Your feedback and comments (optional)
              </label>
              <Textarea
                id="comments"
                placeholder="Comments"
                useInputTheme
                value={values.comments}
                onChange={(value) => setValues({ ...values, comments: value })}
              />
            </div>
          </div>
        </>
      )}

      {!isRequestSuccessful && (
        <Button
          type={ButtonType.CONTINUE}
          disabled={!isFormAnswered || isLoading}
          onClick={onSubmit}
        />
      )}
    </>
  );
};

export { FeedbackForm };
